// extracted by mini-css-extract-plugin
module.exports = {"container":"ti","list":"ui"};